export function checkIOSPowerSavingMode() {
  return new Promise((resolve) => {
    // Accepts video element
    var videoElement = document.querySelector('#ios-power-save-mode-checker');
    if (!videoElement) {
      resolve(false); // No video element found
      return;
    }
    var videoPlayPromise = videoElement.play();
    if (videoPlayPromise !== undefined) {
      videoPlayPromise
        .then(_ => {
          resolve(false); // Video played successfully
        })
        .catch((error) => {
          if (error.name === "NotAllowedError") {
            console.log("Power saving mode detected");
            resolve(true); // Power saving mode detected
          } else {
            resolve(false); // Some other error, not related to power saving mode
          }
        });
    } else {
      resolve(false); // Video play promise is undefined
    }
  });
}
